import React, {useEffect, useState} from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { TABLES } from '../../../../../Apis/Tables';
import {GetActiveExtraOrders} from '../../../../../reduxToolkit/FoodieExtraMeal/FoodieExtraMealApi';
import CustomTh from "../../../../../components/table/CustomTh";
import CustomTd from "../../../../../components/table/CustomTd";
import {
    DetailsIconsOptions,
    IconAvatarTable,
    IconScheduleTable,
    NextIconsOptions
} from "../../../../../components/buttons/IconButtons";
import {
    DATE_TIME_FORMAT_NAME_MODEL,
    EMPTY_VALUES,
    errorMsg,
    getDateFormat,
    getFullName
} from "../../../../../Apis/functions";
import CustomChip from "../../../../../components/CustomChip";
import CustomTooltip from "../../../../../components/CustomTooltip";
import {userType} from "../../../../../enums/userTypeEnum";
import {colors} from "../../../../../enums/colors";
import {statusBorderColor, statusColor, statusFontColor} from "../../../../../enums/statusColorEnum";
import {status, STATUS_MODEL} from "../../../../../enums/statusEnum";
import DropDownMenuProfile from "../../../../../components/DropDown/DropDownMenuProfile";
import DropDownMenuItem from "../../../../../components/DropDown/DropDownMenuItem";
import {permissionObj} from "../../../../../Helpers/permission";
import routes from "../../../../../Routes/routes";
import {SUB_VIEW_MODEL, TABS_FOODIE} from "../../Model/Models";
import TableFunction from "../../../../../components/table/TableFunction";
import {ApproveMultipleRequestMeals} from "../../../../../reduxToolkit/ApprovalTracker/ApprovalTrackerApi";
import {APPROVAL_TRACKER_DECISION_MODEL, getToastMessageByStatus} from "../../../ApprovalTracker/Model/Model";
import {toast} from "react-toastify";
import {DEFAULT_LEFT, LEFT_FIRST_COLUMN_WITH_CHECKBOX} from "../../../../../components/table/Model/TableModel";
/**
 * @Email : sgarcia@ibl.mx
 * @Author: Susana Garcia Rodriguez
 * @jobTittle: Frontend
 */
const RequestMealsTableApp = ({
                                  setItemSelected,
                                  setSummaryModalShow,
                                  modified,
                                  setModified,
                                  searchElement,
                                  setBodyForExport,
                                  option
}) => {
    const dispatch = useDispatch();
    // Redux state: development flag and permissions
    const DEV = useSelector((state) => state?.CommonsSlice?.development);
    const { user, permission } = useSelector((state) => state.authenticatioauthennSlice);
    const userId = user?.data?.id;
    // Local state for managing table data, searches, and selections
    const [searchResults, setSearchResults] = useState('');
    const tableId = 'tbl_rmt_request_meals';
    const searchId =  'txt_rmt_search_request_meals';
    const [showApprovedModal, setShowApprovedModal] = useState(false);
    const [showApproveButton, setShowApproveButton] = useState(false);
    const [selectedList, setSelectedList] = useState([]);
    const [listDisabled, setListDisabled] = useState([]);
    const [isAllChecked, setIsAllChecked] = useState(false);
    const [leftPosition, setLeftPosition] = useState(DEFAULT_LEFT);
    const approvePermission = (DEV || (permission?.includes(permissionObj?.WEB_APPROVAL_FLOW_UPDATE) && permission?.includes(permissionObj?.WEB_APPROVAL_FLOW_READ)));
    const multipleApprovePermission = approvePermission && listDisabled.length !== searchResults?.content?.length;

    const getThead = () => {
        return [
            <CustomTh tableId={tableId} fixedXY={true} left={leftPosition} classes='first_head'>
                {t('request_by')}
            </CustomTh>,
            <CustomTh tableId={tableId}>{t('user_type')}</CustomTh>,
            <CustomTh tableId={tableId}>{t('request_date')}</CustomTh>,
            <CustomTh tableId={tableId}>{t('serving_date')}</CustomTh>,
            <CustomTh tableId={tableId}>{t('service_time')}</CustomTh>,
            <CustomTh tableId={tableId}>{t('approval_status')}</CustomTh>,
        ];
    };
    const getTbody = () => {
        if (!searchResults || searchResults?.content?.length === 0)
            return {
                body: [],
                data: [],
            };

        let disabled = [];
        let body = searchResults?.content?.map((item) => {
            const borderFirstTd = item.canApprove ? `${ multipleApprovePermission ?
                'box-shadow-secondary-400-top-bottom' :
                'box-shadow-secondary-400-top-bottom-left'}` :
                '';
            const borderDefaultTd = item.canApprove ? 'box-shadow-secondary-400-top-bottom': '';
            if(isDisabled(item)) disabled.push(item);

            return (
                <>
                    <CustomTd tableId={tableId} fixed={true} left={leftPosition} classes={`first-column ${borderFirstTd}`}>
                        <div className={"d-flex align-items-center"}>
                            <div>
                                <IconAvatarTable className={"mr-8px mb-1"} />
                            </div>
                            <CustomTooltip
                                text={getFullName(item?.userName, item?.userLastName, item?.userSecondLastName)}
                                classes={`fs-14px font-color-general-950 text-ellipsis`}
                                showIfTruncated={true}
                            />
                        </div>
                    </CustomTd>
                    <CustomTd tableId={tableId} classes={borderDefaultTd}>
                        <CustomChip
                            legend={userType[item?.userTypeId] ? t(userType[item?.userTypeId]) : EMPTY_VALUES.DEFAULT}
                            fontColor={colors.secondary700}
                            borderColor={colors.secondary150}
                            background={colors.secondary100}
                        />
                    </CustomTd>
                    <CustomTd tableId={tableId} classes={borderDefaultTd}>
                        <IconScheduleTable className={"mr-8px mb-1 icon-color-general-950"} />
                        {item?.createdAt
                            ? getDateFormat(item.createdAt, false, DATE_TIME_FORMAT_NAME_MODEL.shortMonth)
                            : EMPTY_VALUES.DEFAULT}
                    </CustomTd>
                    <CustomTd tableId={tableId} classes={borderDefaultTd}>
                        <IconScheduleTable className={"mr-8px mb-1 icon-color-general-950"} />
                        {item?.servingDate
                            ? getDateFormat(item.servingDate, false, DATE_TIME_FORMAT_NAME_MODEL.shortMonth)
                            : EMPTY_VALUES.DEFAULT}
                    </CustomTd>
                    <CustomTd tableId={tableId} classes={borderDefaultTd}>
                        { item?.mealTimeName ?
                            <CustomChip
                                background={colors.secondary100}
                                fontColor={colors.secondary700}
                                borderColor={colors.secondary150}
                                legend={item?.mealTimeName}
                                variant={'compact'}
                            />
                            :
                            EMPTY_VALUES.DEFAULT
                        }
                    </CustomTd>
                    <CustomTd tableId={tableId} classes={`${borderDefaultTd}`}>
                        <CustomChip
                            background={statusColor[item?.approvalStatusId]}
                            fontColor={statusFontColor[item?.approvalStatusId]}
                            borderColor={statusBorderColor[item?.approvalStatusId]}
                            legend={t(status[item?.approvalStatusId]) || EMPTY_VALUES.DEFAULT}
                            variant={'large'}
                        />
                    </CustomTd>
                </>
            );
        });

        setListDisabled(disabled);
        setLeftPosition(multipleApprovePermission ? LEFT_FIRST_COLUMN_WITH_CHECKBOX : DEFAULT_LEFT)
        return {
            body: body,
            data: searchResults?.content?.map(e => ({
                ...e,
                trClass: e.canApprove ? 'background-secondary-50 background-hover-secondary-100': '',
                tdCheckboxClass: e.canApprove ? 'box-shadow-secondary-400-top-bottom-left': '',
                tdActionsClass: e.canApprove ? 'box-shadow-secondary-400-top-bottom-right': ''
            }))
        };
    };

    const getActionsButtons = (item, index) => {
        return (
            <>
                <DropDownMenuProfile openMenu={openMenu} handleMenuToggle={handleMenuToggle} menuId={`menu-${item.id}`}>
                    <DropDownMenuItem
                        index={index}
                        handleClose={handleClose}
                        name={t('details')}
                        icon={<DetailsIconsOptions />}
                        click={() => {
                            setItemSelected(item);
                            setSummaryModalShow(true);
                        }}
                    />
                    { approvePermission && item?.approvalFlowId && (
                        <DropDownMenuItem
                            handleClose={handleClose}
                            id={'btn_eta_approval-tracker' + item.id}
                            index={index}
                            name={t('approval_tracker')}
                            url={{
                                pathname: routes.approvalTracker.main + TABLES.FOODIE_REQUEST + '/' + item?.id + '/' + item?.approvalFlowId,
                                state: {
                                    backUrl:{
                                        pathname: routes.foodie.list,
                                        state: {
                                            currentTab: TABS_FOODIE.REQUESTS.INDEX,
                                            currentSubView: SUB_VIEW_MODEL.REQUEST.REQUEST
                                        }
                                    }
                                }
                            }}
                            icon={<NextIconsOptions/>}
                        />
                    )}
                </DropDownMenuProfile>
            </>
        );
    };

    /**
     * Executes a paginated search request using basic criteria.
     *
     * Builds the request body with the current page, page size, selected model,
     * and any additional criteria passed as arguments.
     * Triggers the search action through Redux and updates the results on success.
     */
    const getData = (page, { searchElement }) => {
        const body = {
            currentDate: Date.now(),
            key: searchElement,
            pagination: {
                page: page,
                size: rowsPerPage,
            },
        };
        setBodyForExport({
            ...body,
            model: option,
            userId: userId
        });
        dispatch(GetActiveExtraOrders(body)).then(
            ({
                 payload: {
                     data: { data, success },
                 },
             }) => {
                if (success === true) {
                    const content = data?.content?.map(e => ({...e, disabled: isDisabled(e)})) || [];
                    setSearchResults({...data, content });
                }
            },
        );
    }

    const isDisabled = (e) => {
        return !e.canApprove || e.approvalStatusId !== STATUS_MODEL.PENDING_REVIEW;
    }

    /**
     * Pagination for list view, and other
     */
    const {
        t,
        thead,
        tbody,
        openMenu,
        handleMenuToggle,
        handleClose,
        pagination,
        rowsPerPage,
        handleCheckboxChange,
        handleDeleteAll
    } = TableFunction({
        data : searchResults,
        selectedList,
        setSelectedList,
        setIsAllChecked,
        labelRowsPerPage: 'request_per_page',
        getTbody,
        getThead,
        fixedPagination: false,
        hasContainer: true,

        searchElement, //New
        getData,//New
        modified,//New
        setModified,//New
    });

    // Enable approve button only when items are selected
    useEffect(() => {
        if (selectedList?.length > 0) {
            setShowApproveButton(true);
        } else {
            setShowApproveButton(false);
        }
    }, [selectedList]);

    const handleApprovalAll = (reason) => {
        const rows = searchResults?.content?.filter(e => selectedList.includes(e.id));
        if(rows.length === 0) return;

        const aux = [];
        rows.forEach(e => {
                const data = {...APPROVAL_TRACKER_DECISION_MODEL,
                    approvalFlowId: e?.approvalFlowId,
                    reason: reason || null,
                    subjectId: e?.id,
                }
                aux.push(data.toRegister());
        })
        dispatch(ApproveMultipleRequestMeals(aux)).then(({payload: {data: { success, code }}}) => {
            if(success){
                setSelectedList([]);
                setListDisabled([]);
                setIsAllChecked(false);
                setModified(true);
                toast.success(t(getToastMessageByStatus(STATUS_MODEL.APPROVED)));
            }else errorMsg(code)
        });
    };

    return {
        t,
        tableId,
        searchId,
        thead,
        tbody,
        getActionsButtons,
        pagination,
        showApproveButton,
        showApprovedModal,
        setShowApprovedModal,
        handleApprovalAll,
        selectedList,
        setSelectedList,
        isAllChecked,
        setIsAllChecked,
        handleCheckboxChange,
        handleDeleteAll,
        listDisabled,

        rowsPerPage,
        results:searchResults,
        setResults: setSearchResults,
        getData,
        multipleApprovePermission
    };
};

export default RequestMealsTableApp;
